<template>
    <div v-if="editable">
        <div v-if="checkEditableCondition(editableCondition, value)">
            <div
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                :class="[getStatusClass(value.id), 'badge']"
            >
                <span>{{ value.label }}</span>
                <i class="icon-expandmore"></i>
            </div>
            <div class="dropdown-menu dropdown-menu-right">
                <template v-for="(option, optionIndex) in options">
                    <a
                        class="dropdown-item"
                        :key="optionIndex"
                        v-if="checkEditableOptionVisibility(editableCondition, value, option)"
                        @click="changeSelectOption(option)"
                    >
                        {{ option.label }}
                    </a>
                </template>
            </div>
        </div>

        <span v-else :class="[getStatusClass(value.id), 'badge']">{{ value.label }}</span>
    </div>

    <span v-else>{{ value.label }}</span>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);

export default {
    props: ["id", "editable", "editableCondition", "value", "options"],

    data() {
        return {
            statusClass: {
                request: "arclight",
                request_approved: "success",
                request_rejected: "danger",
                paid: "success",
                overdue: "danger",
                default: "arclight",
                gray_dark_text: "light-gray dark-text",
            },
        };
    },

    methods: {
        checkEditableCondition(editableCondition, record) {
            if (editableCondition) {
                var editable = false;
                editableCondition.include.forEach(function (rule) {
                    if (rule.condition == record.id) {
                        editable = true;
                    }
                });
                return editable;
            } else {
                return true;
            }
        },

        checkEditableOptionVisibility(editableCondition, record, option) {
            if (editableCondition) {
                var editable = false;
                editableCondition.include.forEach(function (rule) {
                    if (rule.condition == record.id) {
                        if (rule.options.includes(option.id)) {
                            editable = true;
                        }
                    }
                });
                return editable;
            } else {
                return true;
            }
        },

        changeSelectOption(option) {
            this.$emit("change", option);
        },

        getStatusClass(status) {
            if (status in this.statusClass) {
                return this.statusClass[status];
            }

            return this.statusClass["default"];
        },
    },
};
</script>
